import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import { getSequenceDetail } from "src/services/sequences";
import APP_ROUTES from "src/routes/routes";

const useGetSequenceDetail = (id) => {
  const navigate = usePatchedNavigate();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["sequence-detail", id],
    queryFn: () => getSequenceDetail(id),
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    cacheTime: 0,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    refetch,
    isLoading,
    isError,
    error,
  };
};

export default useGetSequenceDetail;
